import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, "进仓通知", -1)
const _hoisted_3 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_4 = { style: {"height":"100% !important"} }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "link" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "link" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, " ", -1)
const _hoisted_20 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_21 = { style: {"float":"left"} }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"float":"left"} }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "link" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "link" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, " ", -1)
const _hoisted_35 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_36 = {
  key: 0,
  style: {"color":"#f56c6c","font-size":"14px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"70%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                style: {"text-align":"center","font-size":"18px","font-weight":"900"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.Data.CompanyName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { style: {"margin-top":"15px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                style: {"text-align":"center","font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.form.Data.CompanyInfo), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { style: {"margin-top":"15px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                style: {"text-align":"center","font-size":"16px","font-weight":"900"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 进仓通知 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { style: {"margin-top":"5px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_miezz_form, {
                    ref: "refForm",
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form) = $event)),
                    fix: true
                  }, {
                    "form-item": _withCtx(({ item }) => [
                      (item.Prop == 'WarehousingCode')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail != true)
                                ? (_openBlock(), _createBlock(_component_miezz_input, {
                                    key: 0,
                                    trim: false,
                                    modelValue: _ctx.form.Data.WarehousingCode,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.WarehousingCode) = $event)),
                                    placeholder: '请填写'
                                  }, null, 8, ["modelValue"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.isString(_ctx.form.Data.WarehousingCode)), 1))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'ClientCompany')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.ClientCompany)), 1)
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'DispatchPortId')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail != true)
                                ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                    key: 0,
                                    modelValue: _ctx.form.Data.DispatchPortName,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.DispatchPortName) = $event)),
                                    clearable: "",
                                    "fetch-suggestions": _ctx.querySearchDispatchPortIdAsync,
                                    "popper-class": "my-autocomplete",
                                    placeholder: "请填写关键词",
                                    onSelect: _ctx.handleSelectDispatchPortId,
                                    onChange: _ctx.onChangeDispatchPortId,
                                    onClear: _ctx.onChangeDispatchPortId
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.Label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.isString(_ctx.form.Data.DispatchPortName)), 1))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'DestinationPortId')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail != true)
                                ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                    key: 0,
                                    modelValue: _ctx.form.Data.DestinationPortName,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.DestinationPortName) = $event)),
                                    clearable: "",
                                    "fetch-suggestions": _ctx.querySearchDestinationPortIdAsync,
                                    "popper-class": "my-autocomplete",
                                    placeholder: "请填写关键词",
                                    onSelect: _ctx.handleSelectDestinationPortId,
                                    onChange: _ctx.onChangeDestinationPortId,
                                    onClear: _ctx.onChangeDestinationPortId
                                  }, {
                                    default: _withCtx(({ item }) => [
                                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.Label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.isString(_ctx.form.Data.DestinationPortName)), 1))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'DeliveryPlaceLabel')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail != true)
                                ? (_openBlock(), _createBlock(_component_miezz_input, {
                                    key: 0,
                                    trim: false,
                                    modelValue: _ctx.form.Data.DeliveryPlaceLabel,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceLabel) = $event)),
                                    placeholder: '请填写'
                                  }, null, 8, ["modelValue"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.isString(_ctx.form.Data.DeliveryPlaceLabel)), 1))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'ServiceName')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.ServiceName)), 1)
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true),
                      (item.Prop == 'BLNO')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 6,
                            prop: item.Prop,
                            "label-width": "140px",
                            label: item.Label
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isDetail != true)
                                ? (_openBlock(), _createBlock(_component_miezz_input, {
                                    key: 0,
                                    trim: false,
                                    modelValue: _ctx.form.Data.BLNO,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.BLNO) = $event)),
                                    placeholder: '请填写'
                                  }, null, 8, ["modelValue"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.isString(_ctx.form.Data.BLNO)), 1))
                            ]),
                            _: 2
                          }, 1032, ["prop", "label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_row, { style: {"margin-top":"0px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        style: {"text-align":"center","font-size":"16px","font-weight":"900"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 货物信息 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_miezz_form, {
                    ref: "refFormGoods",
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form) = $event)),
                    fix: true
                  }, {
                    "form-item": _withCtx(({ item }) => [
                      (item.Prop == 'SumQuantity')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            "label-width": "0px"
                          }, {
                            default: _withCtx(() => [
                              (item.Prop == 'SumQuantity')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, {
                                          span: 24,
                                          style: {"text-align":"center"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_table, {
                                              ref: "customsPackageTable",
                                              data: _ctx.form.Data.Plans
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_table_column, {
                                                  prop: "Leng",
                                                  label: "长cm"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.Length
                                                    }, _toDisplayString(_ctx.isString(scope.row.Length)), 9, _hoisted_13)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_table_column, {
                                                  prop: "Width",
                                                  label: "宽cm"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.Width
                                                    }, _toDisplayString(_ctx.isString(scope.row.Width)), 9, _hoisted_14)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_table_column, {
                                                  prop: "Height",
                                                  label: "高cm"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.Height
                                                    }, _toDisplayString(_ctx.isString(scope.row.Height)), 9, _hoisted_15)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_table_column, {
                                                  prop: "Volume",
                                                  label: "单件体积CBM"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.Volume
                                                    }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_16)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_table_column, {
                                                  prop: "GrossWeight",
                                                  label: "单件毛重KGS"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.GrossWeight
                                                    }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_17)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_table_column, {
                                                  prop: "DeliveryQuantity",
                                                  label: "送货货量"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                                                      title: scope.row.DeliveryQuantity
                                                    }, _toDisplayString(_ctx.isString(scope.row.DeliveryQuantity)), 9, _hoisted_18)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["data"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 8 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "合计件数",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.SumQuantity)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 8 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "合计毛重",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.SumGrossWeight)) + "KGS ", 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 8 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "合计体积",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.SumVolume)) + "m³ ", 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_19,
                  _createVNode(_component_el_row, { style: {"margin-top":"0px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        style: {"text-align":"center","font-size":"16px","font-weight":"900"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 仓库/堆场/码头信息 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_miezz_form, {
                    ref: "refFormWarehousing",
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form) = $event)),
                    fix: true,
                    style: {"width":"100% !important","margin-top":"10px"}
                  }, {
                    "form-item": _withCtx(({ item }) => [
                      (item.Prop == 'Supplier')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            "label-width": "0px",
                            style: {"width":"200% !important"}
                          }, {
                            default: _withCtx(() => [
                              (item.Prop == 'Supplier')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_el_row, { style: {"width":"100% !important"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "名称",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                                      key: 0,
                                                      modelValue: _ctx.form.Data.WarehouseName,
                                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.WarehouseName) = $event)),
                                                      style: {"width":"100% !important"},
                                                      filterable: "",
                                                      clearable: "",
                                                      "allow-create": "",
                                                      "default-first-option": "",
                                                      "reserve-keyword": false,
                                                      placeholder: "请选择",
                                                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeWarehouseName()))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (item, index) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: item.Value,
                                                            label: item.Label,
                                                            value: item.Label
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", _hoisted_21, _toDisplayString(item.Label), 1),
                                                              (item.Data == true)
                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                    key: 0,
                                                                    style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                                    onClick: ($event: any) => (_ctx.onDeleteWarehouseName(item.Value,index))
                                                                  }, [
                                                                    _createVNode(_component_el_icon, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_Delete)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ], 8, _hoisted_22))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.isString(_ctx.form.Data.WarehouseName)), 1))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "地址",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                                      key: 0,
                                                      modelValue: _ctx.form.Data.Address,
                                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.Address) = $event)),
                                                      style: {"width":"100% !important","background-color":"#fff"},
                                                      filterable: "",
                                                      "allow-create": "",
                                                      "default-first-option": "",
                                                      "reserve-keyword": false,
                                                      placeholder: "请选择"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresss, (item, index) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: item.Label,
                                                            label: item.Label,
                                                            value: item.Label
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", _hoisted_24, _toDisplayString(item.Label), 1),
                                                              _createElementVNode("span", {
                                                                style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                                onClick: ($event: any) => (_ctx.onDeleteAddress(item.Value,index))
                                                              }, [
                                                                _createVNode(_component_el_icon, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_Delete)
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ], 8, _hoisted_25)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.isString(_ctx.form.Data.Address)), 1))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "联系人",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                                      key: 0,
                                                      modelValue: _ctx.form.Data.Contacter,
                                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.Contacter) = $event)),
                                                      clearable: "",
                                                      "fetch-suggestions": _ctx.querySearchContacterAsync,
                                                      "popper-class": "my-autocomplete",
                                                      placeholder: "请填写",
                                                      onSelect: _ctx.handleSelectContacter
                                                    }, {
                                                      default: _withCtx(({ item }) => [
                                                        _createElementVNode("span", _hoisted_27, _toDisplayString(item.Label), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.isString(_ctx.form.Data.Contacter)), 1))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "作业时间",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                                      key: 0,
                                                      modelValue: _ctx.form.Data.WorkTime,
                                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.WorkTime) = $event)),
                                                      clearable: "",
                                                      "fetch-suggestions": _ctx.querySearchWorkTimeAsync,
                                                      "popper-class": "my-autocomplete",
                                                      placeholder: "请描述仓库/堆场/码头作业时间",
                                                      onSelect: _ctx.handleSelectWorkTime
                                                    }, {
                                                      default: _withCtx(({ item }) => [
                                                        _createElementVNode("span", _hoisted_29, _toDisplayString(item.Label), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "fetch-suggestions", "onSelect"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.isString(_ctx.form.Data.WorkTime)), 1))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "路线图",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_miezz_upload, {
                                                      key: 0,
                                                      isSingle: true,
                                                      isTip: false,
                                                      modelValue: _ctx.form.Data.Road,
                                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.Road) = $event)),
                                                      path: "wharf/road",
                                                      accept: "file/*",
                                                      prop: "Road",
                                                      maxSize: 5 * 1024 * 1024
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_icon, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_CloseBold)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                      (_ctx.form.Data.Road!=null && _ctx.form.Data.Road!=undefined && _ctx.form.Data.Road!='')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                                            (_openBlock(), _createBlock(_component_miezz_thumbnail, {
                                                              modelValue: _ctx.form.Data.Road,
                                                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.Road) = $event)),
                                                              key: _ctx.index,
                                                              type: 'file',
                                                              icon: 'DocumentDelete'
                                                            }, null, 8, ["modelValue"]))
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                                            _createVNode(_component_miezz_thumbnail, {
                                                              modelValue: undefined,
                                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((undefined) = $event)),
                                                              type: 'image',
                                                              icon: 'DocumentDelete'
                                                            })
                                                          ]))
                                                    ]))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_34,
                  _createVNode(_component_el_row, { style: {"margin-top":"0px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        style: {"text-align":"center","font-size":"16px","font-weight":"900"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 温馨提示 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_miezz_form, {
                    ref: "refFormTip",
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form) = $event)),
                    fix: true,
                    style: {"width":"100% !important","margin-top":"15px"}
                  }, {
                    "form-item": _withCtx(({ item }) => [
                      (item.Prop == 'Supplier')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            "label-width": "0px",
                            style: {"width":"200% !important"}
                          }, {
                            default: _withCtx(() => [
                              (item.Prop == 'Supplier')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createVNode(_component_el_row, { style: {"width":"100% !important"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            (_ctx.isDetail != true)
                                              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_col, { span: 24 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_form_item, {
                                                          label: "收货截止时间",
                                                          "label-width": "140px"
                                                        }, {
                                                          label: _withCtx(() => [
                                                            (_ctx.form.Data.Type != 20)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, " * "))
                                                              : _createCommentVNode("", true),
                                                            _createTextVNode(" 收货截止时间 ")
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_col, { span: 12 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_form_item, {
                                                                  label: "",
                                                                  "label-width": "0px",
                                                                  prop: _ctx.form.Data.Type != 20?'ReceivingDate':''
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_date_picker, {
                                                                      modelValue: _ctx.form.Data.ReceivingDate,
                                                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.ReceivingDate) = $event)),
                                                                      style: {"width":"100% !important"},
                                                                      placeholder: "选择日期",
                                                                      format: "YYYY/MM/DD"
                                                                    }, null, 8, ["modelValue"])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["prop"])
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_el_col, { span: 12 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_form_item, {
                                                                  label: "",
                                                                  "label-width": "0px",
                                                                  prop: _ctx.form.Data.Type != 20?'ReceivingTime':'',
                                                                  style: {"float":"right","width":"99% !important"}
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_time_select, {
                                                                      modelValue: _ctx.form.Data.ReceivingTime,
                                                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.ReceivingTime) = $event)),
                                                                      style: {"width":"100% !important"},
                                                                      start: "00:00",
                                                                      step: "00:60",
                                                                      end: "23:00",
                                                                      placeholder: "选择时间"
                                                                    }, null, 8, ["modelValue"])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["prop"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_ctx.isDetail == true)
                                              ? (_openBlock(), _createBlock(_component_el_col, {
                                                  key: 1,
                                                  span: 24
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_form_item, {
                                                      label: "收货截止时间",
                                                      "label-width": "140px"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.CustomsDeadlineString)), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 12 }, {
                                          default: _withCtx(() => [
                                            (_ctx.isDetail != true)
                                              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_col, { span: 24 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_form_item, {
                                                          label: "报关资料截止时间",
                                                          "label-width": "140px"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_col, { span: 12 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_form_item, {
                                                                  label: "",
                                                                  "label-width": "0px",
                                                                  prop: "CustomsDate"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_date_picker, {
                                                                      modelValue: _ctx.form.Data.CustomsDate,
                                                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.CustomsDate) = $event)),
                                                                      style: {"width":"100% !important"},
                                                                      placeholder: "选择日期",
                                                                      format: "YYYY/MM/DD"
                                                                    }, null, 8, ["modelValue"])
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_el_col, { span: 12 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_form_item, {
                                                                  label: "",
                                                                  "label-width": "0px",
                                                                  prop: "CustomsTime",
                                                                  style: {"float":"right","width":"99% !important"}
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_time_select, {
                                                                      modelValue: _ctx.form.Data.CustomsTime,
                                                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.CustomsTime) = $event)),
                                                                      style: {"width":"100% !important"},
                                                                      start: "00:00",
                                                                      step: "00:60",
                                                                      end: "23:00",
                                                                      placeholder: "选择时间"
                                                                    }, null, 8, ["modelValue"])
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_ctx.isDetail == true)
                                              ? (_openBlock(), _createBlock(_component_el_col, {
                                                  key: 1,
                                                  span: 24
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_form_item, {
                                                      label: "报关资料截止时间",
                                                      "label-width": "140px"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.isString(_ctx.form.Data.CustomsDeadlineString)), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, {
                                              label: "备注",
                                              "label-width": "140px"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.isDetail != true)
                                                  ? (_openBlock(), _createBlock(_component_el_input, {
                                                      key: 0,
                                                      modelValue: _ctx.form.Data.Remark,
                                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.Remark) = $event)),
                                                      rows: 10,
                                                      type: "textarea",
                                                      placeholder: "请填写"
                                                    }, null, 8, ["modelValue"]))
                                                  : (_openBlock(), _createBlock(_component_el_input, {
                                                      key: 1,
                                                      modelValue: _ctx.form.Data.Remark,
                                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.Remark) = $event)),
                                                      rows: 10,
                                                      type: "textarea",
                                                      disabled: ""
                                                    }, null, 8, ["modelValue"]))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.bottomButtons,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.bottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClick
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}